export default class SegmentedControlPlugin {
  private readonly segmentedControlElement: HTMLPkSegmentedControlElement;
  private readonly squadWrapperElements: HTMLDivElement[] = Array.from(document.querySelectorAll('.squad-wrapper'));
  private readonly pkChangeListener: (e: CustomEvent) => void;

  constructor(e: HTMLElement) {
    this.segmentedControlElement = e.querySelector('pk-segmented-control');
    this.pkChangeListener = this.handlePkChange.bind(this);
  }

  public init(): void {
    this.segmentedControlElement.addEventListener('pkChange', this.pkChangeListener);
  }

  public off(): void {
    this.segmentedControlElement.removeEventListener('pkChange', this.pkChangeListener);
  }

  private showSelectedTeamSquad(value: string): void {
    this.squadWrapperElements.forEach((elem) => {
      elem.classList.toggle('hidden', elem.dataset.squad !== value);
    });
  }

  private handlePkChange(e: CustomEvent<{ el: HTMLPkSegmentedControlElement; value: string }>): void {
    const { value } = e.detail;
    this.showSelectedTeamSquad(value);
  }
}
